<template>
  <div class="popup-component" :class="{ backdrop: backdrop }">
    <div class="popup-window" :appearance="compAppearance" v-bind="groupProps">
      <div class="popup-content">
        <slot />
      </div>

      <button type="button" class="close-button" @click="close">
        <img :class="{ dark: darkCloseButton }" :src="$assets.svg['close-icon']" alt="" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { useAttrs, computed } from 'vue';

import $assets from '@/assets';

defineOptions({
  name: 'hub-modal',
});

const emit = defineEmits(['close']);
const props = defineProps({
  backdrop: {
    type: Boolean,
    default: true,
  },
  background: {
    type: String,
    default: '#CCCCCC',
  },
  appearance: {
    type: Object,
    default: () => ({ w: 80, h: 70 }),
  },
  darkCloseButton: {
    type: Boolean,
    default: false,
  },
});

const $attrs = useAttrs();

const compAppearance = computed(() => {
  const height = props.appearance.h || 70;
  const width = props.appearance.w || 80;

  return { h: height, w: width };
});

const groupProps = computed(() => {
  function copyObjParams(obj, params) {
    return params.reduce((result, param) => ({ ...result, [param]: obj[param] }), {});
  }

  return copyObjParams($attrs, ['direction', 'align', 'justify', 'color', 'padding', 'radius', 'overflow', 'shadow']);
});

function close() {
  emit('close');
}
</script>

<style scoped>
.popup-component {
  position: fixed;
  top: 0%;
  left: 72px;
  width: calc(100% - 72px);
  height: 100%;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
}

.backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

.popup-window {
  position: relative;
  width: 50%;
  height: 50%;
  max-width: 90%;
  max-height: 90%;

  /* overflow-y: auto; */

  background: white;
}

.popup-content {
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  overflow-y: auto;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;

  width: 24px;
  height: 24px;
  padding: 0;

  background: transparent;
  border: none;
  cursor: pointer;
}

.close-button > img {
  width: 100%;
  height: 100%;

  filter: invert(100%);
}

.close-button > img.dark {
  filter: invert(0%);
}
</style>
